/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query CurrentsQuery($uid: String!) {
    prismic {
      currents(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_CurrentsBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_CurrentsBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_CurrentsBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_CurrentsBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_CurrentsBodyPagenavlinks {
          type
          label
          fields {
            link_text
            link_url_anchor
          }
        },
        ... on PRISMIC_CurrentsBodyDynamicformbuilder {
          type
          label
          primary {
            footer_form_text
            form_anchor_name
            form_post_location
            header_form_text
            marketo_form_id
            munchkin_account_id
            sub_header_form_text
            thank_you_message
            analytics_track
            analytics_action
          }
          fields {
            field_alphanumeric
            field_column_width
            field_error_message
            field_max_length
            field_name
            field_placeholder
            field_post_name
            field_required
            field_type
            field_value
            section_header
            section_sub_header
          }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Currents = ({ data, location }) =>
  data.prismic.currents ? (
    <MainLayout location={location} layout='currents'>
    <Helmet>
      <title>{(data.prismic.currents.title[0] && data.prismic.currents.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.currents.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.currents.path : 'https://www.digitalocean.com' + data.prismic.currents.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.currents.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.currents.title[0] ? data.prismic.currents.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.currents.description ? data.prismic.currents.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.currents.open_graph_image ? data.prismic.currents.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.currents.description ? data.prismic.currents.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.currents.title[0] ? data.prismic.currents.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.currents.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.currents.path : 'https://www.digitalocean.com' + data.prismic.currents.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.currents.open_graph_image ? data.prismic.currents.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.currents.body} />
    </MainLayout>
  ) : null;

Currents.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Currents;
